const LoadingFallback = () => (
  <div>Loading...</div>
);

export default LoadingFallback;